module.exports = __webpack_public_path__ + "img/chat_emoticon_tipos_08.png?5225186c1c8d89b37dd72325e2fb2cc2";